import { useProSidebar } from 'react-pro-sidebar'
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar'

import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined'
import {
    BlueButtonStory,
    DisabledButtonStory,
    LinkButtonStory,
    PrimaryButtonStory,
    SecondaryButtonStory,
} from './Button.stories'
import { useState } from 'react'
import { DatePickerStory } from './DatePicker.stories'
import { NotificationManager } from '../GlobalComponents/NotificationManager/NotificationManager'
import {
    FastQuoteInputStory,
    FilterInputStory,
    InternationalPhoneInputStory,
    MoneyInputStory,
    ToggledInputStory,
    ToggleButtonsStory,
} from './Input.stories'
import { DropdownListStory, StyledRadioStory } from './Select.stories'
import { InputLoadingStory, PageLoadingStory } from './Loading.stories'
import {
    ConfirmNotificationStory,
    ErrorNotificationStory,
    SuccessNotficationStory,
    UnsavedNotificationStory,
    WarningNotificationStory,
} from './Notification.stories'

export const Components = () => {
    const { collapseSidebar } = useProSidebar()
    const [componentShown, setComponentShown] = useState(<PrimaryButtonStory />)

    return (
        <div id="app" style={{ height: '100vh', display: 'flex' }}>
            <Sidebar style={{ height: '100vh', backgroundColor: 'darkgrey' }}>
                <Menu>
                    <MenuItem
                        icon={<MenuOutlinedIcon />}
                        onClick={() => {
                            collapseSidebar()
                        }}
                        style={{ textAlign: 'center' }}
                    ></MenuItem>
                    <SubMenu label="Button" icon={<span className="k-icon k-i-button" />}>
                        <MenuItem onClick={() => setComponentShown(<PrimaryButtonStory />)}>
                            Primary
                        </MenuItem>
                        <MenuItem onClick={() => setComponentShown(<SecondaryButtonStory />)}>
                            Secondary
                        </MenuItem>
                        <MenuItem onClick={() => setComponentShown(<BlueButtonStory />)}>
                            Blue
                        </MenuItem>
                        <MenuItem onClick={() => setComponentShown(<LinkButtonStory />)}>
                            Link
                        </MenuItem>
                        <MenuItem onClick={() => setComponentShown(<DisabledButtonStory />)}>
                            Disabled
                        </MenuItem>
                    </SubMenu>
                    <MenuItem
                        icon={<span className="k-icon k-i-calendar-date" />}
                        onClick={() => setComponentShown(<DatePickerStory />)}
                    >
                        Date Picker
                    </MenuItem>
                    <SubMenu label="Input" icon={<span className="k-icon k-i-textbox" />}>
                        <MenuItem onClick={() => setComponentShown(<FilterInputStory />)}>
                            Filter
                        </MenuItem>
                        <MenuItem onClick={() => setComponentShown(<MoneyInputStory />)}>
                            Money Input
                        </MenuItem>
                        <MenuItem
                            onClick={() => setComponentShown(<InternationalPhoneInputStory />)}
                        >
                            Phone Input
                        </MenuItem>
                        <MenuItem onClick={() => setComponentShown(<FastQuoteInputStory />)}>
                            Text Input
                        </MenuItem>
                        <MenuItem onClick={() => setComponentShown(<ToggledInputStory />)}>
                            Toggled Input
                        </MenuItem>
                        <MenuItem onClick={() => setComponentShown(<ToggleButtonsStory />)}>
                            Toggle Buttons
                        </MenuItem>
                    </SubMenu>
                    <SubMenu label="Loading" icon={<span className="k-icon k-i-reload-sm" />}>
                        <MenuItem onClick={() => setComponentShown(<InputLoadingStory />)}>
                            Input Loading
                        </MenuItem>
                        <MenuItem onClick={() => setComponentShown(<PageLoadingStory />)}>
                            Page Loading
                        </MenuItem>
                    </SubMenu>
                    <SubMenu
                        label="Notification"
                        icon={<span className="k-icon k-i-notification" />}
                    >
                        <MenuItem onClick={() => setComponentShown(<SuccessNotficationStory />)}>
                            Success
                        </MenuItem>
                        <MenuItem onClick={() => setComponentShown(<WarningNotificationStory />)}>
                            Warning
                        </MenuItem>
                        <MenuItem onClick={() => setComponentShown(<ErrorNotificationStory />)}>
                            Error
                        </MenuItem>
                        <MenuItem onClick={() => setComponentShown(<ConfirmNotificationStory />)}>
                            Confirm
                        </MenuItem>
                        <MenuItem onClick={() => setComponentShown(<UnsavedNotificationStory />)}>
                            Unsaved
                        </MenuItem>
                    </SubMenu>

                    <SubMenu label="Select" icon={<span className="k-icon k-i-select-box" />}>
                        <MenuItem onClick={() => setComponentShown(<DropdownListStory />)}>
                            Dropdown List
                        </MenuItem>
                        <MenuItem onClick={() => setComponentShown(<StyledRadioStory />)}>
                            Styled Radio
                        </MenuItem>
                    </SubMenu>
                </Menu>
            </Sidebar>
            <NotificationManager key={'notificationsManager'} />
            <main style={{ marginLeft: '1em', marginTop: '2em', width: '100%' }}>
                {componentShown}
            </main>
        </div>
    )
}
